import actionConstants from '../constants/';

const allMerchantsList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const allTransactionsList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const allMerchantSummary = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const leadSummary = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const summaryGraphData = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
};

const allSubMerchantData = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {
    subMerchants: [],
    subMerchantCount: 0
  },
  errorMessage: '',
};

const partnerOnboardingStageList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const initialState = {
  allMerchantsList: { ...allMerchantsList },
  allTransactionsList: { ...allTransactionsList },
  allMerchantSummary: { ...allMerchantSummary },
  leadSummary: { ...leadSummary },
  summaryGraphData: {
    ...summaryGraphData
  },
  allSubMerchantList: {
    ...allSubMerchantData
  },
  partnerOnboardingStageList: { ...partnerOnboardingStageList },
  inviteMerchant: {
    isLoading: false,
    isSuccess: false,
    isFailure: false,
    errorCode: 0,
    data: {},
    errorMessage: '',
  },
  paymentMethods: {
    isLoading: false,
    isSuccess: false,
    isFailure: false,
    errorCode: 0,
    data: [],
    errorMessage: '',
  },
  commissionSummary: {
    isLoading: false,
    isSuccess: false,
    isFailure: false,
    data: {},
  },
  commissionBreakdown: {
    isLoading: false,
    isSuccess: false,
    isFailure: false,
    data: {},
  },
  incentivePlan: {
    isLoading: false,
    isSuccess: false,
    isFailure: false,
    data: {},
  },
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function partnerMerchantsReducer(state = initialState, action) {
  switch (action.type) {
    case actionConstants.GET_ALL_MERCHANT_LIST_REQUEST:
      return {
        ...state,
        allMerchantsList: {
          ...state.allMerchantsList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.GET_ALL_MERCHANT_LIST_SUCCESS:
      return {
        ...state,
        allMerchantsList: {
          ...state.allMerchantsList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };
    case actionConstants.GET_ALL_MERCHANT_LIST_FAILURE:
      return {
        ...state,
        allMerchantsList: {
          ...state.allMerchantsList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorCode: 0
        },
      };
    case actionConstants.GET_ALL_MERCHANT_LIST_CLEAR:
      return {
        ...state,
        allMerchantsList: {
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorCode: 0
        },
      };
    case actionConstants.GET_ALL_TRANSACTION_LIST_REQUEST:
      return {
        ...state,
        allTransactionsList: {
          ...state.allTransactionsList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.GET_ALL_TRANSACTION_LIST_SUCCESS:
      return {
        ...state,
        allTransactionsList: {
          ...state.allTransactionsList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };
    case actionConstants.GET_ALL_TRANSACTION_LIST_FAILURE:
      return {
        ...state,
        allTransactionsList: {
          ...state.allTransactionsList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorCode: 0
        },
      };
    case actionConstants.GET_ALL_TRANSACTION_LIST_CLEAR:
      return {
        ...state,
        allTransactionsList: {
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
        },
      };

      case actionConstants.GET_ALL_MERCHANT_SUMMARY_REQUEST:
        return {
          ...state,
          allMerchantSummary: {
            ...state.allMerchantSummary,
            isLoading: true,
            isSuccess: false,
            isFailure: false,
            errorCode: 0,
          },
        };  

    case actionConstants.GET_ALL_MERCHANT_SUMMARY_SUCCESS:
      return {
        ...state,
        allMerchantSummary: {
          ...state.allMerchantSummary,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload?.body
        },
      };

    case actionConstants.GET_ALL_MERCHANT_SUMMARY_FAILURE:
      return {
        ...state,
        allMerchantSummary: {
          ...state.allMerchantSummary,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorCode: 0,
        },
      };

    case actionConstants.GET_ALL_MERCHANT_SUMMARY_CLEAR:
      return {
        ...state,
        allMerchantSummary: {
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
        },
      };

    case actionConstants.GET_LEAD_SUMMARY_REQUEST:
      return {
        ...state,
        leadSummary: {
          ...state.leadSummary,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_LEAD_SUMMARY_SUCCESS:
      return {
        ...state,
        leadSummary: {
          ...state.leadSummary,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload?.body,
        },
      };

    case actionConstants.GET_LEAD_SUMMARY_FAILURE:
      return {
        ...state,
        leadSummary: {
          ...state.leadSummary,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorCode: 0,
        },
      };

    case actionConstants.GET_LEAD_SUMMARY_CLEAR:
      return {
        ...state,
        leadSummary: {
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
        },
      };

    case actionConstants.GET_PARTNER_SUMMARY_GRAPH_REQUEST:
      return {
        ...state,
        summaryGraphData: {
          ...state.summaryGraphData,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.GET_PARTNER_SUMMARY_GRAPH_SUCCESS:
      return {
        ...state,
        summaryGraphData: {
          ...state.summaryGraphData,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };
    case actionConstants.GET_PARTNER_SUMMARY_GRAPH_FAILURE:
      return {
        ...state,
        summaryGraphData: {
          ...state.summaryGraphData,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: 0
        },
      };
    case actionConstants.GET_PARTNER_SUMMARY_GRAPH_CLEAR:
      return {
        ...state,
        summaryGraphData: {
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: [],
        },
      };
    case actionConstants.GET_PARTNER_SUB_MERCHANT_LIST_SUCCESS:
      return {
        ...state,
        allSubMerchantList: {
          ...state.allSubMerchantList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };
    case actionConstants.GET_PARTNER_SUB_MERCHANT_LIST_FAILURE:
      return {
        ...state,
        allSubMerchantList: {
          ...state.allSubMerchantList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {
            subMerchants: [],
            subMerchantCount: 0
          },
          errorCode: 0
        },
      };
    case actionConstants.GET_PARTNER_SUB_MERCHANT_LIST_CLEAR:
      return {
        ...state,
        allSubMerchantList: {
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {
            subMerchants: [],
            subMerchantCount: 0
          },
        },
      };

    case actionConstants.GET_PARTNER_ONBOARDING_STAGE_LIST_REQUEST:
      return {
        ...state,
        partnerOnboardingStageList: {
          ...state.partnerOnboardingStageList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.GET_PARTNER_ONBOARDING_STAGE_LIST_SUCCESS:
      return {
        ...state,
        partnerOnboardingStageList: {
          ...state.partnerOnboardingStageList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload?.body,
        },
      };
    case actionConstants.GET_PARTNER_ONBOARDING_STAGE_LIST_FAILURE:
      return {
        ...state,
        partnerOnboardingStageList: {
          ...state.partnerOnboardingStageList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorCode: 0,
        },
      };
    case actionConstants.GET_PARTNER_ONBOARDING_STAGE_LIST_CLEAR:
      return {
        ...state,
        partnerOnboardingStageList: {
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
        },
      };

    case actionConstants.INVITE_PARTNER_MERCHANT_REQUEST:
      return {
        ...state,
        inviteMerchant: {
          ...state.inviteMerchant,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.INVITE_PARTNER_MERCHANT_SUCCESS:
      return {
        ...state,
        inviteMerchant: {
          ...state.inviteMerchant,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload?.body,
        },
      };
    case actionConstants.INVITE_PARTNER_MERCHANT_FAILURE:
      return {
        ...state,
        inviteMerchant: {
          ...state.inviteMerchant,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorCode: action?.payload?.body?.error_details?.errorCode ?? 0,
          errorMessage: action?.payload?.body?.error_details?.errorMessage ?? '',
        },
      };
    case actionConstants.INVITE_PARTNER_MERCHANT_CLEAR:
      return {
        ...state,
        inviteMerchant: {
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
        },
      };

    case actionConstants.GET_PARTNER_PAYMENT_METHODS_REQUEST:
      return {
        ...state,
        paymentMethods: {
          ...state.paymentMethods,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.GET_PARTNER_PAYMENT_METHODS_SUCCESS:
      return {
        ...state,
        paymentMethods: {
          ...state.paymentMethods,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload?.body,
        },
      };
    case actionConstants.GET_PARTNER_PAYMENT_METHODS_FAILURE:
      return {
        ...state,
        paymentMethods: {
          ...state.paymentMethods,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: [],
          errorCode: 0,
        },
      };
    case actionConstants.GET_PARTNER_PAYMENT_METHODS_CLEAR:
      return {
        ...state,
        paymentMethods: {
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: [],
        },
      };

    // ─── Commission Summary ────────────────────────────────────────────────
    case actionConstants.GET_COMMISSION_SUMMARY_REQUEST:
      return { ...state, commissionSummary: { ...state.commissionSummary, isLoading: true, isSuccess: false, isFailure: false } };
    case actionConstants.GET_COMMISSION_SUMMARY_SUCCESS:
      return { ...state, commissionSummary: { ...state.commissionSummary, isLoading: false, isSuccess: true, isFailure: false, data: action.payload.body?.data || {} } };
    case actionConstants.GET_COMMISSION_SUMMARY_FAILURE:
      return { ...state, commissionSummary: { ...state.commissionSummary, isLoading: false, isSuccess: false, isFailure: true, data: {} } };
    case actionConstants.GET_COMMISSION_SUMMARY_CLEAR:
      return { ...state, commissionSummary: { isLoading: false, isSuccess: false, isFailure: false, data: {} } };

    // ─── Commission Breakdown ──────────────────────────────────────────────
    case actionConstants.GET_COMMISSION_BREAKDOWN_REQUEST:
      return { ...state, commissionBreakdown: { ...state.commissionBreakdown, isLoading: true, isSuccess: false, isFailure: false } };
    case actionConstants.GET_COMMISSION_BREAKDOWN_SUCCESS:
      return { ...state, commissionBreakdown: { ...state.commissionBreakdown, isLoading: false, isSuccess: true, isFailure: false, data: action.payload.body?.data || {} } };
    case actionConstants.GET_COMMISSION_BREAKDOWN_FAILURE:
      return { ...state, commissionBreakdown: { ...state.commissionBreakdown, isLoading: false, isSuccess: false, isFailure: true, data: {} } };
    case actionConstants.GET_COMMISSION_BREAKDOWN_CLEAR:
      return { ...state, commissionBreakdown: { isLoading: false, isSuccess: false, isFailure: false, data: {} } };

    // ─── Incentive Plan ────────────────────────────────────────────────────
    case actionConstants.GET_INCENTIVE_PLAN_REQUEST:
      return { ...state, incentivePlan: { ...state.incentivePlan, isLoading: true, isSuccess: false, isFailure: false } };
    case actionConstants.GET_INCENTIVE_PLAN_SUCCESS:
      return { ...state, incentivePlan: { ...state.incentivePlan, isLoading: false, isSuccess: true, isFailure: false, data: action.payload.body?.data || {} } };
    case actionConstants.GET_INCENTIVE_PLAN_FAILURE:
      return { ...state, incentivePlan: { ...state.incentivePlan, isLoading: false, isSuccess: false, isFailure: true, data: {} } };
    case actionConstants.GET_INCENTIVE_PLAN_CLEAR:
      return { ...state, incentivePlan: { isLoading: false, isSuccess: false, isFailure: false, data: {} } };

    default:
      return {
        ...state,
      };
  }
}


